/* ============================================================================
   Rover - Homepage fused-hero + site-wide "Ask Rover" bar behaviours.
   Loaded by the Rover section on the homepage, and by theme.liquid on
   collection/product pages (where #rover-app is absent). Talks to the existing
   DOM + the public window.Rover hook; does NOT touch rover-finder.js internals.
   ============================================================================ */
(function () {
  "use strict";
  var app = document.getElementById("rover-app");        // homepage only
  var sticky = document.getElementById("rover-sticky");  // site-wide (except cart/checkout)
  if (!app && !sticky) return;

  function $(id) { return document.getElementById(id); }

  function headerH() {
    var h = document.querySelector(".site-header-wrapper") || document.querySelector("[data-site-header]");
    if (!h) return 0;
    var pos = getComputedStyle(h).position;
    var r = h.getBoundingClientRect();
    return (pos === "fixed" || pos === "sticky") && r.top <= 1 ? r.height : 0;
  }

  function track(ev, detail) {
    detail = detail || {};
    detail.event = "rover_" + ev;
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(detail); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent("rover:" + ev, { detail: detail, bubbles: true })); } catch (e) {}
  }

  function smoothTo(el, extra) {
    if (!el) return;
    var y = el.getBoundingClientRect().top + window.pageYOffset - headerH() - (extra || 8);
    window.scrollTo({ top: Math.max(0, y), behavior: "smooth" });
  }

  // Run a query through the on-page Rover (homepage). Uses the public window.Rover hook.
  function runOnPage(q) {
    if (window.Rover && typeof window.Rover.search === "function") { window.Rover.search(q); return true; }
    var qm = $("q-main"), f = $("form-hero");
    if (qm) qm.value = q;
    if (f) { if (f.requestSubmit) f.requestSubmit(); else f.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true })); return true; }
    return false;
  }
  function whenRoverReady(cb, tries) {
    tries = tries == null ? 40 : tries;
    if (window.Rover && typeof window.Rover.search === "function") { cb(); return; }
    if (tries <= 0) { cb(); return; }
    setTimeout(function () { whenRoverReady(cb, tries - 1); }, 100);
  }

  /* ============================ HOMEPAGE FEATURES ============================ */
  if (app) {
    function openRover(seed, submit) {
      smoothTo(app, 8);
      var q = $("q-main");
      if (q) { if (seed != null) q.value = seed; try { q.focus({ preventScroll: true }); } catch (e) { q.focus(); } }
      if (submit && seed) runOnPage(seed);
    }

    /* 1) Mobile VIN/plate disclosure */
    var disc = $("fit-disclosure");
    if (disc) disc.addEventListener("click", function () {
      var open = app.classList.toggle("fit-open");
      disc.setAttribute("aria-expanded", open ? "true" : "false");
      if (open) { var p = $("hero-plate"); if (p) { try { p.focus({ preventScroll: true }); } catch (e) {} } }
    });

    /* 2) Secondary shortcuts */
    function modelSection() {
      var byId = document.getElementById("shop-by-model");
      if (byId) return byId;
      var hs = document.querySelectorAll("h2, h3");
      for (var i = 0; i < hs.length; i++) if (/shop by model|per model|modellen/i.test(hs[i].textContent || "")) return hs[i].closest("section") || hs[i];
      var sec = app.closest("section") || app, n = sec.nextElementSibling;
      while (n) { if (/collection-list|dynamic-collection/i.test(n.className || "") || (n.querySelector && n.querySelector(".collection__item"))) return n; n = n.nextElementSibling; }
      return null;
    }
    document.addEventListener("click", function (e) {
      var sc = e.target.closest && e.target.closest(".rv-shortcut");
      if (!sc) return;
      var kind = sc.getAttribute("data-rv-shortcut");
      track("secondary_path_click", { path: kind });
      if (kind === "browse") {
        var href = sc.getAttribute("href") || "";
        if (href.charAt(0) === "#" || href === "") { e.preventDefault(); var t = modelSection(); if (t) smoothTo(t, 8); else openRover(); }
      }
    }, false);

    /* 3) Clickable rating -> scroll to the on-page reviews (eTrusted) section */
    function reviewsSection() {
      var w = document.querySelector("etrusted-widget");
      if (w) return w.closest("section") || w;
      var hs = document.querySelectorAll("h2, h3");
      for (var i = 0; i < hs.length; i++) if (/trusted by|reviews|beoordel/i.test(hs[i].textContent || "")) return hs[i].closest("section") || hs[i];
      return null;
    }
    document.addEventListener("click", function (e) {
      var r = e.target.closest && e.target.closest("[data-rv-reviews]");
      if (!r) return;
      track("secondary_path_click", { path: "rating_reviews" });
      var t = reviewsSection(); if (t) smoothTo(t, 12);
    }, false);

    /* 4) Analytics on Rover's own actions */
    ["form-hero", "form-results"].forEach(function (id) {
      var f = $(id);
      if (f) f.addEventListener("submit", function () { track("query", { q: ((f.querySelector("input") || {}).value || "").trim().slice(0, 120), source: id }); }, false);
    });
    document.addEventListener("click", function (e) {
      var ch = e.target.closest && e.target.closest("#suggest-chips .chip");
      if (ch) track("query", { q: (ch.getAttribute("data-seed") || "").slice(0, 120), source: "chip" });
      var rb = e.target.closest && e.target.closest("[data-resolve]");
      if (rb) track("fit_check", { source: "garage", method: rb.getAttribute("data-resolve") });
      var a = e.target.closest && e.target.closest("#cards a[href], #zero-cards a[href]");
      if (a && /\/products\//.test(a.getAttribute("href") || "")) track("handoff", { url: a.getAttribute("href") });
    }, false);
    var hc = $("hero-check"); if (hc) hc.addEventListener("click", function () { track("fit_check", { source: "hero" }); }, false);

    /* 5) ?rover_q hand-off from the site-wide bar -> run it through on-page Rover */
    try {
      var rq = new URLSearchParams(window.location.search).get("rover_q");
      if (rq && rq.trim()) {
        var qq = rq.trim();
        var qm0 = $("q-main"); if (qm0) qm0.value = qq;
        whenRoverReady(function () { runOnPage(qq); track("query", { q: qq.slice(0, 120), source: "sitewide_bar" }); });
        if (window.history && history.replaceState) {
          var u = new URL(window.location.href); u.searchParams.delete("rover_q"); history.replaceState({}, "", u.toString());
        }
      }
    } catch (e) {}
  }

  /* ============================ "ASK ROVER" BAR ============================ */
  if (sticky) {
    var sf = $("rover-sticky-form"), sq = $("rover-sticky-q");
    var inflow = sticky.classList.contains("inflow");

    if (inflow) {
      if (sf) sf.addEventListener("submit", function () {
        track("secondary_path_click", { path: "sticky", view: "inflow", q: ((sq || {}).value || "").trim().slice(0, 120) });
      }, false);
    } else {
      /* Reveal on scroll-UP only (2026-08-12). The header now carries the primary search box,
         so this bar is an assist, not a permanent band. Rules:
           - never while near the top: the real header (and its box) is still on screen
           - scrolling DOWN always hides it, so it can never sit over the collection filter
             drawer, the sort control, or anything else the customer is reaching for
           - any drawer/menu trigger hides it immediately; drawers also scroll-lock the body,
             which stops scroll events firing at all while they are open
           - z-index 50 keeps it under Empire's drawers/modals (1110+) regardless */
      function place() { sticky.style.top = headerH() + "px"; }
      function show() {
        if (sticky.classList.contains("show")) return;
        place(); sticky.classList.add("show"); sticky.setAttribute("aria-hidden", "false");
      }
      function hide() {
        if (!sticky.classList.contains("show")) return;
        sticky.classList.remove("show"); sticky.setAttribute("aria-hidden", "true");
      }

      /* No requestAnimationFrame throttle here on purpose: rAF does not fire in a
         non-rendering tab, and a latched "queued" flag would freeze the bar until the
         tab was painted again. The work is one class toggle, the listener is passive,
         and show()/hide() are idempotent — so handling every event directly is both
         cheaper to reason about and testable outside a rendering context. */
      var MIN_Y = 260, DELTA = 6;
      var lastY = window.pageYOffset || 0;

      function onScroll() {
        var y = window.pageYOffset || 0;
        if (y <= MIN_Y) { hide(); lastY = y; return; }
        if (y < lastY - DELTA) show();
        else if (y > lastY + DELTA) hide();
        lastY = y;
      }

      hide();
      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", function () { if (sticky.classList.contains("show")) place(); });
      document.addEventListener("click", function (e) {
        if (!e.target || !e.target.closest) return;
        if (e.target.closest(".utils-filter-button, [data-filter-drawer-toggle], .site-header-menu-toggle, .mobile-navmenu-button, [data-mobile-nav-toggle], [data-drawer-toggle], .productgrid--sidebar-toggle")) hide();
      }, true);
      if (sf) sf.addEventListener("submit", function (e) {
        e.preventDefault();
        var v = ((sq || {}).value || "").trim();
        track("secondary_path_click", { path: "sticky", view: "fixed", q: v.slice(0, 120) });
        if (app) { smoothTo(app, 8); var qm = $("q-main"); if (qm) qm.value = v; if (v) runOnPage(v); else { try { qm.focus(); } catch (e2) {} } }
        else if (v) { window.location.href = "/?rover_q=" + encodeURIComponent(v); }
      }, false);
    }
  }
})();
